import axios from "axios";

const initialState = {};

export const addParticipantReducer = (state = initialState, action) => {
  return state;
};

const addParticipant = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/invite`, formData)
    .then(({ data }) => {
      return Promise.resolve({
        message: "Participant created successfully",
        participant: { participantId: data?.id, userName: data?.ugnxId },
      });
    })
    .catch((e) => {
      return Promise.reject(
        e.response?.data
          ? e.response?.data
          : "The participant is already associated with that Study."
      );
    });
};

export const mapDispatchToProps = {
  addParticipant,
};
